export default defineNuxtRouteMiddleware((to, from) => {
    if (to.matched.length === 0) {
        // 如果沒有匹配到路由，則重定向到首頁
        return navigateTo('/');
    }
});
